import { makeSelectors } from '@utils/css';

const containerTransitionDurationMs = {
  enter: 100,
  exit: 100
};
const itemTransitionDurationMs = {
  enter: 300,
  exit: 225
};
const wrapper = "dibw1ne5qai";
const container = "dibc6e1lkl";
const item = "dibi11v8sj1";
const toastsContainerSelectors = makeSelectors({
  wrapper
});

export { container, containerTransitionDurationMs, item, itemTransitionDurationMs, toastsContainerSelectors, wrapper };
import "./organism.toast-container.style.linaria.module.css";
//# sourceMappingURL=organism.toast-container.style.js.map
